import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Loading from '../Loading/Loading.jsx';
import { corseLink, notionApiHeaders, notionApiLink } from '../constant.js';
import JobItem from '../JobItem/JobItem.jsx';

export default function JobList() {

    // const jobs = [
    //     {
    //         role: "Software Instructor",
    //         companyName: "MEC Academy",
    //         type: "Part-time",
    //         duration: "Jul 2023 - Present",
    //         description: [
    //             "Leads weekly instructional sessions for groups of 20 or more individuals.",
    //             "Developing and implementing instructional materials.",
    //             "Providing mentoring and guidance to students.",
    //         ],
    //     },
    //     {
    //         role: "Software Engineer",
    //         companyName: "Ejada",
    //         type: "Full-time",
    //         duration: "Oct 2024 - Mar 2025",
    //         description: [
    //             "Design, develop, and test software applications.",
    //             "Collaborate with cross-functional teams to define and implement new features.",
    //             "Work with stakeholders to gather requirements and translate them into software solutions.",
    //         ],
    //     },
    //     {
    //         role: "Full Stack Developer",
    //         companyName: "Qodera",
    //         type: "Internship",
    //         duration: "Sep 2024 - Nov 2024",
    //         description: [
    //             "Design, develop, and test web applications.",
    //             "Collaborate with cross-functional teams to define and implement new features.",
    //             "Write clean, efficient, and maintainable code.",
    //             "Troubleshoot and debug issues to optimize performance.",
    //             "Participate in code reviews to ensure quality and adherence to best practices.",
    //         ],
    //     },
    //     {
    //         role: "Web Developer",
    //         companyName: "Sync Intern’s",
    //         type: "Internship",
    //         duration: "Jul 2023 - Aug 2023",
    //         description: [
    //             "Assisted in website development tasks and projects.",
    //             "Learned and applied new web development technologies and techniques.",
    //         ],
    //     },
    // ];

    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getJobsIcon = async () => {
            try {
                setLoading(true);
                const response = await axios.post(
                    corseLink + notionApiLink("1b911e5fc811800e9437f0fc8df46742"),
                    {
                        "sorts": [
                            {
                                "property": "Order",
                                "direction": "ascending"
                            }
                        ],
                    },
                    {
                        headers: notionApiHeaders,
                    }
                );
                // console.log("Response results:", response.data.results);
                const jobsList = [];
                response.data.results.forEach(item => {
                    jobsList.push({
                        companyName: item.properties.Name.title[0].plain_text,
                        type: item.properties.JobType.select.name,
                        role: item.properties.Role.rich_text[0].plain_text,
                        duration: item.properties.Duration.rich_text[0].plain_text,
                        description: item.properties.Description.rich_text[0].plain_text.split('$'),
                    })
                });
                setJobs(jobsList);
                // console.log("jobsList:", jobsList);
            } catch (error) {
                console.log("Error:", error);
            }
            setLoading(false);
        };
        getJobsIcon();
    }, []);


    if (loading) return <div className='w-full flex justify-center'>
        <Loading />
    </div>


    return (<>
        {jobs.map((item, index) => <JobItem key={index} jobDetails={item} />)}
    </>)
}
